"use client";
import { Skeleton } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { GetDataInputElement, getLinkValue, getValueLabel, getValueList } from "./inputFunction";
import { LinkButton, CopyButton } from "./inputButton";
import { Debug } from "@/util/debug";
import Link from "antd/es/typography/Link";
import { Flex } from "antd";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { appRouterPush, getPrefetch, isAndroidRouter, useLinkRouter } from "@/util/apputil";
import { useRouter } from "next/navigation";
export default function LinkDisplay(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const router = useRouter();
  const valueList = getValueList("set", params);
  //const value =    params.fixedValue ?? (valueList ? getValueLabel(params.value, valueList) : params.transition ?? false ? t(params.value) : params.value);
  const [pathName, setPathName] = useState(params.linkOption?.pathname);
  const [value, setValue] = useState(
    params.fixedValue ??
      (valueList ? getValueLabel(params.value, valueList) : (params.transition ?? false) ? t(params.value) : params.value),
  );

  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setLinkPathName"] = setPathName;
      temp_function["setLinkValue"] = setValue;
    }
  }

  useEffect(() => {
    setValue(
      params.fixedValue ??
        (valueList ? getValueLabel(params.value, valueList) : (params.transition ?? false) ? t(params.value) : params.value),
    );
  }, [params.fixedValue, params.value, params.transition, t, valueList]);

  if (value == null || value == undefined) {
    return <Skeleton loading={params.loading ?? false}>{(params.loading ?? false) ? "blank" : " "}</Skeleton>;
  } else {
    //Debug(params);
    const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
    const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
    const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
    const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
    const title = params.linkPropOption?.text
      ? params.linkPropOption?.text
      : params.linkPropOption?.title
        ? (params.linkPropOption?.titleTransition ?? true)
          ? t(params.linkPropOption.title)
          : params.linkPropOption.title
        : params.linkPropOption?.titleField
          ? params.values[params.linkPropOption.titleField]
          : decodeURIComponent(value);
    const target = params.linkProp?.target ? params.linkProp?.target : params.linkPropOption?.newTab ? "_blank" : undefined;
    // Debug(params, target);
    const linkValue = getLinkValue(
      params.linkOption?.useHost,
      params.linkOption?.useEncode,
      params.linkOption?.site,
      pathName,
      params.values,
      value,
      params.linkOption?.prevIds,
      params.valueJoin,
    );
    const useLinkButton = params.linkPropOption?.linkButtonUse ?? true;
    const link_href =
      target === undefined && linkValue.indexOf(window.location.origin.toString()) === 0
        ? linkValue.substring(window.location.origin.toString().length)
        : undefined;
    // Debug("linkValue", window.location.origin.toString(), linkValue, link_href, target);

    return (
      <Skeleton loading={params.loading ?? false}>
        <Flex className={cn(params.inputClassName)}>
          {prev}
          {useLinkButton && params.linkPropOption?.linkButtonFront ? <LinkButton {...params} value={linkValue} /> : ""}
          {params.copyProp?.copyButton && params.copyProp?.copyButtonFront ? <CopyButton {...params} value={linkValue} /> : ""}
          {unitPrev}
          <Link
            href={linkValue}
            {...params.linkProp}
            target={target}
            className={cn(params.linkProp?.className ?? "mt-[0.3rem] font-bold")}
            onClick={
              useLinkRouter && isAndroidRouter() && link_href
                ? (e) => {
                    e.preventDefault();
                    appRouterPush(router, link_href);
                  }
                : undefined
            }
          >
            {title}
          </Link>
          {unit}
          {params.copyProp?.copyButton && !params.copyProp?.copyButtonFront ? <CopyButton {...params} value={linkValue} /> : ""}
          {!useLinkButton || params.linkPropOption?.linkButtonFront ? "" : <LinkButton {...params} value={linkValue} />}
          {next}
        </Flex>
      </Skeleton>
    );
  }
}
